import React from "react";
import { Slide1 } from "./Slide1";
import { Slide2 } from "./Slide2";

export const ContentBlock = () => {

  return(
    <div className="home-content">
      <Slide1 />
      <Slide2 />
    </div>
  )
}
